import { Stack, Text, useMediaQuery } from "native-base";
import React from "react";
import { View } from "react-native";

const Summary = ({ User }) => {
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });

	return (
		<View>
			<Stack mx="4" space={3}>
				<Text>
					You will not be able to sign in until your proof of identity has been
					moderated and your employment verified. You will be alerted via
					email/SMS once your account has been activated.
				</Text>
				{Object.keys(User).map((key, index) => {
					if (
						key === "Password" ||
						key === "Confirm Password" ||
						key === "ID/Passport Document" ||
						key === "Role" ||
						key === "Store"
					)
						return;
					return (
						<>
							{User[key].description ? (
								<View
									style={
										isDesktopOrLaptop[0]
											? {
													borderBottomWidth: "1px",
													padding: "5px",
													borderBottomColor: "#cecece",
											  }
											: {}
									}
								>
									<View
										key={index}
										style={
											isDesktopOrLaptop[0]
												? {
														flexDirection: "row",
														justifyContent: "space-between",
														marginLeft: "50px",
														marginRight: "50px",
												  }
												: {
														flexDirection: "row",
														justifyContent: "space-between",
												  }
										}
									>
										<Text>{key}</Text>
										<Text>{User[key].description}</Text>
									</View>
								</View>
							) : (
								<View
									style={
										isDesktopOrLaptop[0]
											? {
													borderBottomWidth: "1px",
													padding: "5px",
													borderBottomColor: "#cecece",
											  }
											: {}
									}
								>
									<View
										key={index}
										style={
											isDesktopOrLaptop[0]
												? {
														flexDirection: "row",
														justifyContent: "space-between",
														marginLeft: "50px",
														marginRight: "50px",
												  }
												: {
														flexDirection: "row",
														justifyContent: "space-between",
												  }
										}
									>
										<Text>{key}</Text>
										<Text>{User[key]}</Text>
									</View>
								</View>
							)}
						</>
					);
				})}
			</Stack>
		</View>
	);
};

export default Summary;
